"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var index_1 = require("../../../_Core/index");
var index_2 = require("../../../Buttons/index");
var Localization_1 = require("../../../Localization");
var index_3 = require("../../../Theme/index");
var DateTimeHelper_1 = require("../DateTimeHelper");
var Header_styles_1 = require("./Header.styles");
exports.Header = (function (_a) {
    var date = _a.date, changeYear = _a.changeYear, changeMonth = _a.changeMonth, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled, YearOptionsMaxOffset = _a.YearOptionsMaxOffset, YearOptionsMinOffset = _a.YearOptionsMinOffset;
    var selectStyles = {
        control: function (provided) { return (__assign(__assign({}, provided), { alignItems: "center", border: "none", display: "flex", fontFamily: index_3.FontFamily, fontSize: "14px !important", fontWeight: "bold", letterSpacing: "0.02em", lineHeight: "130%" })); },
        indicatorSeparator: function () { return ({
            display: "none",
        }); },
        placeholder: function (provided) { return (__assign(__assign({}, provided), { color: index_3.Color.Grey.G60, fontWeight: "normal" })); },
        singleValue: function (provided) { return (__assign(__assign({}, provided), { color: index_3.Color.Grey.G70 })); },
    };
    var Months = function () { return DateTimeHelper_1.getMonthsOptions(); };
    var getMonthsValue = function () {
        return Months().find(function (x) { return x.value === date.getMonth(); });
    };
    var Years = function () { return DateTimeHelper_1.getYearsOptions(YearOptionsMinOffset, YearOptionsMaxOffset); };
    var getYearValue = function () {
        return Years().find(function (x) { return x.value === date.getFullYear(); });
    };
    return (React.createElement(Header_styles_1.Container, null,
        React.createElement(index_2.IconButton, { OnClick: decreaseMonth, Disabled: prevMonthButtonDisabled, AriaLabel: Localization_1.strings.DateTimePicker_Action_PreviousMonth, ButtonSize: "26px", IconSize: "24px", Icon: index_1.Icons.ChevronLeft, Title: Localization_1.strings.DateTimePicker_Label_PreviousMonth }),
        React.createElement(Header_styles_1.SelectWrapper, null,
            React.createElement(react_select_1.default, { options: Months(), value: getMonthsValue(), onChange: function (option) { return changeMonth(option.value); }, closeMenuOnSelect: true, "aria-label": Localization_1.strings.DateTimePicker_Message_SelectMonth, styles: selectStyles })),
        React.createElement(Header_styles_1.SelectWrapper, null,
            React.createElement(react_select_1.default, { options: Years(), value: getYearValue(), onChange: function (option) { return changeYear(option.value); }, closeMenuOnSelect: true, "aria-label": Localization_1.strings.DateTimePicker_Message_SelectYear, styles: selectStyles })),
        React.createElement(index_2.IconButton, { OnClick: increaseMonth, Disabled: nextMonthButtonDisabled, AriaLabel: Localization_1.strings.DateTimePicker_Action_NextMonth, ButtonSize: "26px", IconSize: "24px", Icon: index_1.Icons.ChevronRight, Title: Localization_1.strings.DateTimePicker_Label_NextMonth })));
});
